import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, InfoSystemDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class InfoSystemsStore {
  infoSystems: InfoSystemDto[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.infoSystems.getInfoSystems();
    runInAction(() => {
      this.infoSystems = data?.map((infoSystem) => ({ ...infoSystem, id: infoSystem.code })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const infoSystemsStore = new InfoSystemsStore({ api: cmApi });
